import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GetPinnedPipelineItemsCountForUserQueryVariables = Types.Exact<{
   params: Types.GetPinnedPipelineItemsCountForUserParams
}>

export type GetPinnedPipelineItemsCountForUserQuery = {
   __typename?: 'Query'
   getPinnedPipelineItemsCountForUser: {
      __typename?: 'PinnedPipelineItemsCountResult'
      totalCount: number
   }
}

export const GetPinnedPipelineItemsCountForUserDocument = gql`
   query GetPinnedPipelineItemsCountForUser(
      $params: GetPinnedPipelineItemsCountForUserParams!
   ) {
      getPinnedPipelineItemsCountForUser(params: $params) {
         totalCount
      }
   }
`
export type GetPinnedPipelineItemsCountForUserQueryResult = Apollo.QueryResult<
   GetPinnedPipelineItemsCountForUserQuery,
   GetPinnedPipelineItemsCountForUserQueryVariables
>
